

(function showErrorDirectiveDefinition() {

    'use strict';

    angular.module('Errors')
        .directive('editableShowError', [
            function showErrorDirective() {
                return {
                    restrict: 'A',
                    priority: -1,
                    link: function showErrorClassDirectiveLink(scope, element, attrs) {

                        scope.validate = function(fieldScope) {
                            if (angular.element(fieldScope.$editable.inputEl).controller('ngModel').$valid)
                                return null;
                            return 'Error';
                        };
                        attrs.onbeforesave = "validate(this)";
                    }
                };
            }
        ]);

})();